import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import axios from 'axios';
import NoAccessPage from './Auth/NoAccessPage';
import LeadForm from './Lead/LeadForm';

const authToken =
  ')d45UnzdL&&(Z#Ka2RzDYG#retRIyfn)ySjFUqFm$e|)ArMA$gVT0fpc10@ypCXA';

const LeadTokenValidator = () => {
  const [isValidToken, setIsValidToken] = useState(null);

  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  const leadToken = queryParams.token;

  useEffect(() => {
    const validateToken = async () => {
      try {
        await axios.get(
          `https://api.amco.pt/api/leads/token?leadToken=${leadToken}`,
          { headers: { Authorization: `Bearer ${authToken}` } }
        );
        setIsValidToken(true);
      } catch (error) {
        setIsValidToken(false);
      }
    };

    if (leadToken) validateToken();
    else setIsValidToken(false);
  }, [leadToken]);

  if (isValidToken === null) {
    return <div>A obter dados da lead...</div>;
  }

  return isValidToken ? <LeadForm token={leadToken} /> : <NoAccessPage />;
};

export default LeadTokenValidator;
